<template>
    <div class="modal">
        <icon class="modal-closer" name="close" v-if="!isLoading && !disallowClose" @click="handleClose"/>
        <div class="modal-header" v-if="$slots.title || $scopedSlots.title || title">
            <div class="modal-title">
                <slot name="title">{{ title }}</slot>
            </div>
        </div>
        <div class="modal-body">
            <loading-indicator v-if="isLoading"/>
            <template v-else>
                <slot>
                    <div v-html="body"/>
                </slot>
            </template>
        </div>
        <div v-if="!isLoading && (actions.length > 0 || !!$slots.footer || !!$scopedSlots.footer)" class="modal-footer">
            <slot name="footer">
                <panel xs="wrap">
                    <btn v-for="(action, index) in actions"
                         :key="index"
                         v-bind="mergeActionDefaults(action)"
                    />
                </panel>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {type: String, default: ''},
            body: {type: String, default: ''},
            loading: {type: Boolean, default: false},
            disallowClose: {type: Boolean, default: false},
            disallowShadowClose: {type: Boolean, default: false},
            actions: {type: Array, default: () => []},
        },

        computed: {
            isLoading() {
                return this.loading || this.$loading('modal');
            },
        },

        methods: {
            closeOnClick(ev) {
                if (ev.which === 1 && ev.target.classList.contains('modals') && !this.isLoading && !this.disallowClose && !this.disallowShadowClose) {
                    this.handleClose();
                }
            },

            closeOnEsc(ev) {
                if (ev.keyCode === 27 && !this.isLoading && !this.disallowClose) {
                    this.handleClose();
                }
            },

            handleClose() {
                if (this.$parent.$el.classList.contains('modals')) {
                    this.$emit('close');
                } else {
                    this.$parent.$emit('close');
                }
            },

            mergeActionDefaults(action) {
                return {size: 'lg', theme: 'secondary', context: this, ...action};
            },
        },

        mounted() {
            if (document.activeElement instanceof Element && !this.$ui.nodeHasParent(document.activeElement, this.$el)) {
                document.activeElement.blur();
            }
            document.body.addEventListener('keyup', this.closeOnEsc);
            document.querySelector('.modals').addEventListener('mousedown', this.closeOnClick);
        },

        beforeDestroy() {
            document.body.removeEventListener('keyup', this.closeOnEsc);
            document.querySelector('.modals').removeEventListener('mousedown', this.closeOnClick);
        },
    };
</script>
